import AuthenticationService from 'business/services/AuthenticationService';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { clearUserDataAndLogout, delay, removeCookie } from 'utils/Global';

const API_REQ_WAIT_MS = 500;

const authService = new AuthenticationService();

const useLogoutUser = () => {
  const history = useHistory();

  const logoutUser = useCallback(async () => {
    const logout = authService.logoutUser();
    // HACK: makesure the api request has been sent
    await delay(API_REQ_WAIT_MS);

    clearUserDataAndLogout();

    try {
      await logout;
    } catch (error) {
      console.warn('Logout API failed or cookie missing:', error);
    }
  }, [history]);

  return logoutUser;
};

export default useLogoutUser;
